export type BrandDocStatus = 'draft' | 'in_progress' | 'approved' | 'published'

export const BRAND_DOC_STATUSES: readonly BrandDocStatus[] = [
  'draft',
  'in_progress',
  'approved',
  'published',
]

export interface BrandDocMeta {
  readonly version: number
  readonly status: BrandDocStatus
  readonly createdAt: string | null
  readonly updatedAt: string | null
  readonly confirmedAt: string | null
}

export const DRAFT_BRAND_DOC_META: BrandDocMeta = {
  version: 0,
  status: 'draft',
  createdAt: null,
  updatedAt: null,
  confirmedAt: null,
}
